/**
 * Bootstrap Icons class names for “experience” bullets on venue cards.
 * Curated for Party Boss / theatre context; admins can still type any class manually.
 */
export const THEATRE_EXPERIENCE_ICONS = [
  "bi-heart-fill",
  "bi-star-fill",
  "bi-stars",
  "bi-ticket-perforated-fill",
  "bi-film",
  "bi-camera-reels-fill",
  "bi-camera-video-fill",
  "bi-collection-play-fill",
  "bi-display",
  "bi-projector",
  "bi-volume-up-fill",
  "bi-music-note-beamed",
  "bi-mic-fill",
  "bi-headphones",
  "bi-lightbulb-fill",
  "bi-balloon-fill",
  "bi-balloon-heart-fill",
  "bi-gift-fill",
  "bi-cake2-fill",
  "bi-cup-straw",
  "bi-emoji-smile-fill",
  "bi-hand-thumbs-up-fill",
  "bi-award-fill",
  "bi-patch-check-fill",
  "bi-shield-fill-check",
  "bi-people-fill",
  "bi-person-hearts",
  "bi-calendar-event-fill",
  "bi-clock-fill",
  "bi-geo-alt-fill",
  "bi-building",
  "bi-door-open-fill",
  "bi-tv-fill",
  "bi-speaker-fill",
  "bi-sparkle",
  "bi-magic",
  "bi-controller",
  "bi-dice-5-fill",
  "bi-image-fill",
  "bi-palette-fill",
  "bi-wifi",
  "bi-badge-hd-fill",
  "bi-currency-rupee",
  "bi-cup-hot-fill",
  "bi-fire",
];
